import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import HealthHistory from './Component/HealthHistory';

const getSelectedChild = (state) => state.child.childList && state.child.childList.length && state.child.childList[state.child.selectedChild || 0]

const mapStateToProps = (state, ownProps) => ({
    user: state.auth.userProfile,
    child: getSelectedChild(state) || {},

    isUpdating: state.child.updateChild.isUpdating,
    updateStatus: state.child.updateChild.status,
    updateError: state.child.updateChild.error
});


const mapDispatchToProps = (dispatch) => ({
    saveHealthHistory: (payload) => dispatch(Actions.updateUser(payload, {action: Actions.responseUpdateChildUser})),
    fetchChildList: (userId) => dispatch(Actions.fetchChildList({ userId }))
});


export default connect(mapStateToProps, mapDispatchToProps)(HealthHistory)